<template>
  <div>
    <div class="vx-row flex flex-col">
      <div class="vx-col w-full">
        <vs-card>
          <div slot="header">
            <h3>Tambah Dinas</h3>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input
                type="text"
                icon-after="true"
                icon-pack="feather"
                icon="icon-user"
                placeholder="Nama Dinas"
                class="w-full"
                v-model="agency.name"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input
                type="text"
                icon-after="true"
                icon-pack="feather"
                icon="icon-user"
                placeholder="Inisial Dinas"
                class="w-full"
                v-model="agency.initial"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-textarea
                type="text"
                label="Alamat Lengkap"
                class="mb-3"
                v-model="agency.address"
              />
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-input
                type="number"
                icon-after="true"
                icon-pack="feather"
                icon="icon-phone"
                placeholder="No. Telepon"
                class="w-full"
                v-model="agency.phone"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-textarea type="text" label="Deskripsi" class="mb-3" v-model="agency.description" />
            </div>
          </div>
          <!-- <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-upload
                action="https://jsonplaceholder.typicode.com/posts/"
                @on-success="()=>  {}"
              />
            </div>
          </div> -->
          <div class="vx-row mb-3 mt-3">
            <div class="vx-col w-full">
              <span><strong>Logo Instansi</strong> (Opsional)</span><br><br>
              <input type="file" class="mb-4" ref="file" @change="handleFileUpload()" accept="image/jpeg, image/png, image/jpg">
            </div>
          </div>
          <div class="vx-col mb-3">
            <div class="vx-row w-full">
              <div class="flex flex-row">
                <vs-button
                  @click="createAgency"
                  class="ml-4"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-send"
                  type="filled"
                >Simpan</vs-button>
                <vs-button
                  @click="$router.push({name: 'agencies'})"
                  class="ml-2"
                  color="primary"
                  icon-pack="feather"
                  icon="icon-arrow-left"
                  type="border"
                >Kembali</vs-button>
              </div>
            </div>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  data() {
    return {
      agency: {
        name: "",
        phone: "",
        address: "",
        logo: "",
        description: "",
        initial : "",
        files: [],
      }
    };
  },
  components: {
    "v-select": vSelect
  },
  methods: {
    handleFileUpload(){
      this.agency.files[0] = this.$refs.file.files[0];
    },
    async createAgency() {
      var self = this;

      const headers = { 'Content-Type': "multipart/form-data; charset=utf-8; boundary=" + Math.random().toString().substr(2),};
      let data = this.getStoreParams();
      self.$vs.loading();

      await this.$http.post(`/app/secure/agency`, data, {headers : headers})
        .then(() => {
          self.$vs.notify({
            title: "Sukses",
            text: "Berhasil menyimpan data dinas.",
            color: "success",
            position: "top-right"
          });
          self.$router.push({name: 'agencies'});
        })
        .catch(error => {
          self.parseError(error);
          this.$vs.loading.close();
        });
    },
    getStoreParams(){
      const formData = new FormData();
      formData.append("name", this.agency.name);
      formData.append("phone", this.agency.phone);
      formData.append("address", this.agency.address);
      formData.append("logo", this.agency.logo);
      formData.append("initial", this.agency.initial);
      formData.append("description", this.agency.description);
      this.agency.files.forEach(file => {
          return formData.append("attachments[]", file);
      });
      return formData;
    },
    // createAgency() {
    //   this.$vs.loading();
    //   this.$http
    //     .post(`/app/secure/agency/`, this.agency)
    //     .then(() => {
    //       this.$vs.notify({
    //         title: "Sukses",
    //         text: "Berhasil menyimpan data dinas.",
    //         color: "success",
    //         position: "top-right"
    //       });
    //       this.clearModel();
    //     })
    //     .catch(e => {
    //       this.parseError(e);
    //     })
    //     .finally(() => {
    //       this.$vs.loading.close();
    //     });
    // },
    clearModel() {
      for (let i in this.agency) {
        this.agency[i] = "";
      }
    }
  }
};
</script>